import { configureStore } from '@reduxjs/toolkit';
import authReducer from '@cubemeet/core/store/slices/authSlice';
import travelsReducer from '@cubemeet/core/store/slices/travelsSlice';
import chatReducer from '@cubemeet/core/store/slices/chatSlice';
import todosReducer from '@cubemeet/core/store/slices/todosSlice';
import friendsReducer from '@cubemeet/core/store/slices/friendsSlice';
// Include the expenseReceipts reducer so web can access receipts state and thunks
import expenseReceiptsReducer from '@cubemeet/core/store/slices/expenseReceiptsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer as unknown as any,
    travels: travelsReducer as unknown as any,
    chat: chatReducer as unknown as any,
    todos: todosReducer as unknown as any,
    friends: friendsReducer as unknown as any,
    // wire expenseReceipts so fetchGroupReceipts and uploadReceipt can update store
    expenseReceipts: expenseReceiptsReducer as unknown as any,
  },
});

export type RootState = any;
export type AppDispatch = typeof store.dispatch;
